
/**
 * Компонент с примитивными фильтрами расположенными на красной плашке
 */
import { onMounted, onUnmounted, ref } from '@vue/composition-api';
import debounce from 'lodash.debounce';
import type { BaseFilter } from '~/type/Filter';
interface Props {
  list: BaseFilter[];
  value?: BaseFilter;
  /**
  * Ручное переключение видимости ресета у фильтров, обычно вручную переключать не нужно и компонент врубает ресет только если передано событие
  */
  enableReset: boolean;
  /**
  * Тип тега у списка фильтров
  */
  tag: 'div' | 'a';
}
const __sfc_main = {};
__sfc_main.props = {
  list: {
    key: "list",
    required: true,
    type: Array
  },
  value: {
    key: "value",
    required: false,
    type: null
  },
  enableReset: {
    key: "enableReset",
    required: false,
    type: Boolean,
    default: true
  },
  tag: {
    key: "tag",
    required: false,
    type: String,
    default: 'div'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const expanded = ref(false);
  const active = ref(false);
  const hiddenWrapper = ref();
  const resizeHandler = debounce(needToBeActive, 300);
  function onChange(obj?: BaseFilter) {
    if (props.value?.value !== obj?.value) {
      /**
      * Срабатывает при изменении фильтров
      */
      emit('change', obj);
    }
  }
  function onExpandClick() {
    expanded.value = !expanded.value;
    needToBeActive();
  }
  function needToBeActive() {
    if (active.value === false && hiddenWrapper.value.offsetHeight > 20) active.value = true;else if (hiddenWrapper.value.offsetHeight === 20) active.value = false;
  }
  onUnmounted(() => {
    window.removeEventListener('resize', resizeHandler);
  });
  onMounted(() => {
    needToBeActive();
    window.addEventListener('resize', resizeHandler);
  });
  return {
    expanded,
    active,
    hiddenWrapper,
    onChange,
    onExpandClick
  };
};
export default __sfc_main;
